/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

import React from 'react';

const p = console.log

class MasonryColumn extends React.Component {
  
  constructor(props){
    super(props);
    this.onScroll = this.onScroll.bind(this);
    this.height = this.height.bind(this);
    this.length = this.length.bind(this);
    this.addMoreElements = this.addMoreElements.bind(this);
    this.throttle = this.throttle.bind(this);

    this.visibleELements = [];

    this.defaultProps = {
      chunkSize:3
    };

    this.state={
      
      chunkOffset:0,
      containers:[],
      prevChildren:0,
      reset:false
    };
    this.didHookOnScroll = false;


    this.scrollEventHandler = this.throttle(this.onScroll,100);

  }

  throttle(fn, wait) {
      var time = Date.now();
      return function(event) {
        if ((time + wait - Date.now()) < 0) {
          fn(event);
          time = Date.now();
        }
      }
    }

  componentDidMount () {


    // parent.refs[this.props.scrollRef].addEventListener('scroll',this.onScroll,false)
    this.addMoreElements(true);
  }

  componentWillUnmount () {
    if(this.didHookOnScroll){
      const parent = this._reactInternalInstance._currentElement._owner._instance;
      if(parent.refs[this.props.scrollRef]){
        parent.refs[this.props.scrollRef].removeEventListener('scroll',this.scrollEventHandler);
        this.didHookOnScroll = false;
      }
    }
    
  }


  componentDidUpdate(prevProps, prevState){
    // TODO: for some reason parent.refs[this.props.scrollRef] is undefined in mounting process
    // forcing us to have a flag and add this here instead

    const parent = this._reactInternalInstance._currentElement._owner._instance;

    if(this.didHookOnScroll&&prevProps.id!=this.props.id){
      if(parent.refs[this.props.scrollRef]){
        parent.refs[this.props.scrollRef].removeEventListener('scroll',this.scrollEventHandler);
        this.didHookOnScroll = false;
      }
    }

    if(!this.didHookOnScroll){
      if(parent.refs[this.props.scrollRef]){
        parent.refs[this.props.scrollRef].addEventListener('scroll',this.scrollEventHandler);
        this.didHookOnScroll = true;
      }
    }

    

    let prev = this.state.prevChildren
    // let prev = prevProps.children
    let current = this.props.children

    // console.log("--------------------");
    // console.log(prev);
    // console.log(current);
    // console.log(this.state.containers);
    // console.log("--------------------");


    if(prev.length!=current.length){
      this.addMoreElements(true);
    }
  }

  addMoreElements(reset){


    // TODO: This function will gradually change to only making chunks of ALL elements
    // TODO: chunks should have keys which are basically a concat of the elements' keys

    let newContainers = [];
    let newChunkOffset = 0;
    const chunkSize = this.props.chunkSize;
    for (let i = 0; i < this.props.children.length; i++) {
      let child = this.props.children[i];
      // let child = {...this.props.children[i]};
      if(!newContainers.length||newContainers[newContainers.length-1].elements.length>=chunkSize){
        newContainers.push({
          elements:[child],
          height:null,
          visible:true
        })
      }else{
        newContainers[newContainers.length-1].elements.push(child)
      }

      
    }
    this.setState({containers:newContainers, prevChildren:[...this.props.children]})
  }



  length(){
    return this.props.children.length;
  }

  height(){
    // return parseFloat(getComputedStyle(this.refs.elementsContainer).height);
    return this.refs.elementsContainer.clientHeight;
  }
  onScroll(event){

    //If the list is empty
    try{
    if(this.refs.elementsContainer.childNodes[0] == undefined || this.props.chunkSize > this.props.children.length){
      return;
    }
      
    }catch(e){
      console.log(this)
    }

    let scrollTop = event.srcElement.scrollTop;
    let lastElement = this.refs.elementsContainer ? this.refs.elementsContainer.childNodes[this.refs.elementsContainer.childNodes.length-1] : null

    //If it's reached the last container and should fill it up at the bottom
    // if(lastElement && scrollTop>(lastElement.offsetTop-event.srcElement.clientHeight)){
    //   this.addMoreElements();
    //   return;
    // }

    //calculate which chunks to show:
    let viewHeight = event.srcElement.clientHeight;
    let scrollBottom = scrollTop+viewHeight;
    let newContainers = this.state.containers.slice();
    let changed = false;
    let shouldBeVisible = [];

    for (let i = 0; i < this.state.containers.length; i++) {

      let element = this.refs["chunk"+i];
      let top = element.offsetTop;
      let height = element.clientHeight;
      let bottom = top+height;
      //TODO: create points to listen to instead of doing this search all the time
      if((scrollTop>top&&scrollTop<bottom)||(scrollBottom>top&&scrollBottom<bottom)||(scrollTop<top&&scrollBottom>bottom)){
        //should be visible
        shouldBeVisible.push(i);
      }
    };

    if(!shouldBeVisible.length) return;

    if(shouldBeVisible[0] != 0){
      shouldBeVisible.splice(0,0,shouldBeVisible[0]-1)
    }
    
    if(shouldBeVisible[shouldBeVisible.length-1] != this.state.containers.length-1){
      shouldBeVisible.push(shouldBeVisible[shouldBeVisible.length-1]+1)
    }
    for (let i = 0; i < newContainers.length; i++) {
      if(shouldBeVisible.indexOf(i)!=-1){
        if(!newContainers[i].visible){
          newContainers[i].height = 0;
          newContainers[i].visible = true;
          changed = true;
        }
      }else{
        if(newContainers[i].visible){
          newContainers[i].height = parseFloat(getComputedStyle(this.refs["chunk"+i]).height)
          newContainers[i].visible = false;
          changed = true;
        }
      }
      
    };
    if(changed){
      this.setState({containers:newContainers});
    }
  }

  render() {
  
    const style = {
      masonryContainer:{
        height:'100%'
      },
      invisibleChunk:{
        marginTop:'5px',
        // marginTop:'30px',
        // marginBottom:'15px'
      }
    }

    return (
      <div ref="elementsContainer" style={this.props.style}>
          {this.state.containers.map((chunk,index)=>{return (
            <div style={(chunk.height?{...style.invisibleChunk,height:chunk.height}:{})} ref={"chunk"+index} key={this.props.id+"-linear"+index}>
              <div style={(chunk.visible?{}:{display:'none'})} >
                {chunk.elements}
              </div>
            </div>
          )})}
        </div>
    );
  }
}

export default MasonryColumn;